<app-smart-input-entity
  fieldLabel="name"
  [control]="control()"
  [handler]="workPackagePickerHandler()"
  [placeholder]="placeholder()"
  [resetValue]="resetValue()">
  <ng-template
    let-item="item"
    appTemplate="filter">
    @if (cast(item); as status) {
      <app-wp-status-badge
        class="flex w-full max-w-full"
        [wpStatus]="{ name: status.name, color: status.color.text }"></app-wp-status-badge>
    }
  </ng-template>
</app-smart-input-entity>
